/**
 * Keeps track of activity status on the server to display a warning
 * to the user if no activity has been detected
 */

import Axios from "axios";
import Swal from "sweetalert2";
import {loading} from "./loading";

/**
 * How often will the server be queried for activity status, in ms
 * @type {number}
 */
const ACTIVITY_CHECK_FREQUENCY = 45000;

let warningClosedAutomatically = false;

function checkActivityStatus() {
	Axios.get(window['routes/system.activity-status'])
		.then(response => {
			// noinspection JSUnresolvedVariable
			const secondsLeft =
				// Add some additional seconds to give time for the server to log us out
				(parseInt(response.data.secondsBeforeLogout) * 1000) + 10000;

			// noinspection JSUnresolvedVariable
			const inactivityWarning = response.data.inactivityWarning;

			if (inactivityWarning) {
				const timeOutIdForLogout = setTimeout(attemptLogout, secondsLeft);

				warningClosedAutomatically = false;

				Swal.fire({
					title: 'You will be logged out due to inactivity',
					text: 'Please click continue to prevent this',
					icon: 'warning',
					confirmButtonText: 'Continue',
				}).then(() => {
					// User is active, cancel logout
					clearTimeout(timeOutIdForLogout)

					// Start checking again
					setTimeout(checkActivityStatus, ACTIVITY_CHECK_FREQUENCY);

					if (!warningClosedAutomatically) {
						// Make sure server knows we are alive
						Axios.post(window['routes/system.keep-alive'])
							.then()
							.catch(() => {
								// Maybe we are too late, reload page
								loading();
								window.location.reload();
							})
					}
				})
			} else {
				// Continue checking
				setTimeout(checkActivityStatus, ACTIVITY_CHECK_FREQUENCY);
			}
		})
}

/**
 * Called when user showed no signs of activity
 */
function attemptLogout() {
	// Make a last check in case user showed activity somewhere else
	Axios.get(window['routes/system.activity-status'])
		.then(response => {
			// noinspection JSUnresolvedVariable
			const secondsLeft =
				// Add some seconds to give time for the server to log us out
				parseInt(response.data.secondsBeforeLogout) + 10;

			// User still dead, attempt logout
			if (secondsLeft <= 10) {
				// Logout manually
				loading();

				Axios.post(window['routes/system.logout'])
					.finally(() => window.location.reload());
			} else {
				// User showed activity somewhere else, remove Swal warning
				warningClosedAutomatically = true;
				Swal.close()
			}
		})
		.catch(() => {
			// User may already be logged out, reload page
			loading();

			window.location.reload();
		})
}

export {
	ACTIVITY_CHECK_FREQUENCY,
	checkActivityStatus
}
